import React, { useEffect } from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';

const AccessDenied: React.FC = () => {
  useEffect(() => {
    // Redirect to SWA logout immediately
    window.location.href = '/.auth/logout';
  }, []);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom color="error">
            Brak dostępu
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Twoje konto nie ma uprawnień do korzystania z tej aplikacji.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Skontaktuj się z administratorem, jeśli uważasz, że to błąd.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied;
